import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pedidoFilter'
})
export class PedidoFilterPipe implements PipeTransform {
  transform(pedidos: any[], dataInicial: string, dataFinal: string, cliente: string, status: string): any[] {
    if (!pedidos) return [];
    
    return pedidos.filter(pedido => {
      // Filtro por data
      if (dataInicial && new Date(pedido.data) < new Date(dataInicial)) return false;
      if (dataFinal && new Date(pedido.data) > new Date(dataFinal)) return false;
      
      // Filtro por cliente
      if (cliente && !pedido.cliente.toLowerCase().includes(cliente.toLowerCase())) return false;
      
      // Filtro por status
      if (status && pedido.status !== status) return false;
      
      return true;
    });
  }
} 